import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class InfiniteScroll extends Component {
    constructor(props) {
        super(props);

        this._removeListeners = null;
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        this.addListeners();
    }

    componentDidUpdate() {
        if (!this._removeListeners) {
            this.addListeners();
        }
    }

    componentWillUnmount() {
        this.removeListeners();
    }

    addListeners() {
        const {
            hasMore,
            useCapture
        } = this.props;

        if (!hasMore || this._removeListeners) {
            return;
        }

        this._infiniteScroll.parentNode.addEventListener('scroll', this.handleScroll, useCapture);
        this._removeListeners = () => this._infiniteScroll.parentNode.removeEventListener('scroll', this.handleScroll, useCapture);
    }

    removeListeners() {
        if (typeof this._removeListeners === "function") {
            this._removeListeners();
            this._removeListeners = null;
        }
    }

    handleScroll() {
        const {
            _infiniteScroll,
            props: { threshold, loadMore }
        } = this;

        const offset = _infiniteScroll.scrollHeight - _infiniteScroll.parentNode.scrollTop - _infiniteScroll.parentNode.clientHeight;

        if (offset < threshold) {
            this.removeListeners();

            if (typeof loadMore === "function") {
                loadMore();
            }
        }
    }

    render() {
        const {
            children,
            hasMore,
            loader,
            className
        } = this.props;

        const childrenArray = [children];
        if (hasMore && loader) {
            childrenArray.push(loader);
        }
        return (
            <div className={className} ref={node => {this._infiniteScroll = node;}}>{childrenArray}</div>
        );
    }
}

InfiniteScroll.propTypes = {
    hasMore: PropTypes.bool,
    loadMore: PropTypes.func.isRequired,
    threshold: PropTypes.number,
    useCapture: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]).isRequired,
    loader: PropTypes.object
};

InfiniteScroll.defaultProps = {
    threshold: 150,
    useCapture: false,
    loader: null
};



// WEBPACK FOOTER //
// ./src/components/Notifications/InfiniteScroll.jsx